export const firebaseConfig = {
  apiKey: "AIzaSyBZN4mrOOzKus_4Lz9AWLnC17zFS1f5hgc",
  authDomain: "catalyst-hackathon-2022.firebaseapp.com",
  projectId: "catalyst-hackathon-2022",
  storageBucket: "catalyst-hackathon-2022.appspot.com",
  messagingSenderId: "1023601798026",
  appId: "1:1023601798026:web:435bfc5a31f9daba443673"
};